import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FirmInstructionHistoryCollectionModel } from '../../Models/Models/Company/FirmInstructionHistoryCollectionModel';
import { InstructionStatus } from '../../Constants/Enums/Domain/InstructionStatus';
import { FirmProcessType } from '../../Constants/Enums/Domain/FirmProcessType';
import { FirmType } from '../../Constants/Enums/Domain/FirmType';
import { IJsonDate } from '../../System/IJsonDate';
import { GetFirmInstructionsQuery } from '../../Models/Models/Company/GetFirmInstructionsQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class FirmInstructionHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(statuses: Array<InstructionStatus>, firmProcessType: FirmProcessType, firmType: FirmType, firmName: string, tradingReference: string, postCode: string, createUserId: number, startedFromDate: IJsonDate, startedToDate: IJsonDate, updatedFromDate: IJsonDate, updatedToDate: IJsonDate, start: number, count: number): Promise<FirmInstructionHistoryCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/FirmInstructionHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { statuses: statuses, firmProcessType: firmProcessType, firmType: firmType, firmName: firmName, tradingReference: tradingReference, postCode: postCode, createUserId: createUserId, startedFromDate: startedFromDate, startedToDate: startedToDate, updatedFromDate: updatedFromDate, updatedToDate: updatedToDate, start: start, count: count }

    return AjaxWrapper.get<FirmInstructionHistoryCollectionModel, any>(url, data);
  }
  public delete(instructionIds: Array<number>, query: GetFirmInstructionsQuery): Promise<FirmInstructionHistoryCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/FirmInstructionHistory/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { instructionIds: instructionIds, query: query }

    return AjaxWrapper.post<FirmInstructionHistoryCollectionModel, any>(url, data);
  }
}

